"use client";

import React from "react";
import Layout from "@/src/components/layout";
import SEO from "@/src/shared/components/SEO";
import Link from "next/link";

const NotFoundView = () => {
  return (
    <>
      <SEO title="404 | Not Found" description="Page not found on Travela" />
      <Layout>
        <div className="min-h-[80vh] bg-white flex flex-col items-center justify-center text-center py-20">
          <h1 className="text-5xl font-bold text-coral-pink-500 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-ink-black mb-2">
            Page Not Found
          </h2>
          <p className="text-ink-secondary mb-6 max-w-md">
            Sorry, the page you are looking for does not exist or has been
            moved.
          </p>
          <Link
            href="/"
            className="inline-block bg-coral-pink-500 text-white px-6 py-2 rounded-lg font-medium hover:bg-coral-pink-600 transition-colors"
          >
            Go to Homepage
          </Link>
        </div>
      </Layout>
    </>
  );
};

export default NotFoundView;
